module.exports = __webpack_public_path__ + "img/video.b6142809.svg";